(function() {
  'use strict';

  var registry = window.PooleaseSectionScripts = window.PooleaseSectionScripts || {};
  function computeDeckState(scrollProgress, n) {
    if (n <= 0) return { currentStep: 0, centerIndex: 0, transitionProgress: 0, scrollProgress: 0 };
    if (n === 1) return { currentStep: 0, centerIndex: 0, transitionProgress: 0, scrollProgress: 0 };
    var sp = Math.max(0, Math.min(1, scrollProgress));
    var scaled = sp * (n - 1);
    var currentStep = Math.min(n - 1, Math.floor(scaled));
    return {
      currentStep: currentStep,
      centerIndex: Math.min(n - 1, Math.round(scaled)),
      transitionProgress: scaled - currentStep,
      scrollProgress: sp
    };
  }

  function initSection(section) {
    if (!section || section.dataset.productScrollStoryReady === 'true') return;
    var cards = section.querySelectorAll('.product-scroll-story__media-card');
    var strip = section.querySelector('[data-strip]');
    var steps = section.querySelectorAll('.product-scroll-story__step-content');
    var railItems = section.querySelectorAll('.product-scroll-story__rail-item');
    var progressBar = section.querySelector('[data-progress-bar]');

    if (!cards.length || !steps.length) return;
    section.dataset.productScrollStoryReady = 'true';

    var MOBILE_MQ = window.matchMedia('(max-width: 768px)');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var mobileActiveCard = -1;
    var mobileRevealObserver;

    function syncMobileReveals() {
      if (mobileRevealObserver) {
        mobileRevealObserver.disconnect();
        mobileRevealObserver = null;
      }

      section.classList.remove('is-mobile-reveal-ready');
      steps.forEach(function(step) { step.classList.remove('is-revealed'); });
      cards.forEach(function(card) { card.classList.remove('is-revealed'); });
      if (!MOBILE_MQ.matches || reduceMotion) return;

      var revealItems = Array.prototype.slice.call(steps).concat(Array.prototype.slice.call(cards));
      section.classList.add('is-mobile-reveal-ready');

      if (typeof IntersectionObserver === 'undefined') {
        revealItems.forEach(function(item) { item.classList.add('is-revealed'); });
        return;
      }

      mobileRevealObserver = new IntersectionObserver(function(entries) {
        entries.forEach(function(entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-revealed');
            mobileRevealObserver.unobserve(entry.target);
          }
        });
      }, { threshold: 0.12, rootMargin: '0px 0px -8% 0px' });
      revealItems.forEach(function(item) { mobileRevealObserver.observe(item); });
    }

    function syncMobileNarrativeDom() {
      var isMobile = MOBILE_MQ.matches;
      var isLinear = isMobile || reduceMotion;

      cards.forEach(function(card, index) {
        card.removeAttribute('data-mobile-active');
        if (isLinear && steps[index]) {
          steps[index].after(card);
        } else if (strip) {
          strip.appendChild(card);
        }
      });

    }

    syncMobileNarrativeDom();
    syncMobileReveals();
    function onMediaChange() {
      syncMobileNarrativeDom();
      syncMobileReveals();
      update();
    }
    MOBILE_MQ.addEventListener('change', onMediaChange);

    function getSectionProgress() {
      var rect = section.getBoundingClientRect();
      var vh = window.innerHeight || document.documentElement.clientHeight;
      var scrolled = Math.max(0, -rect.top);
      var totalScrollable = Math.max(1, rect.height - vh);
      var edgeBuffer = vh * 0.5;
      var travel = Math.max(1, totalScrollable - edgeBuffer * 2);
      return Math.max(0, Math.min(1, (scrolled - edgeBuffer) / travel));
    }

    // Each card occupies 60% of the visible panel. Liquid sizes the strip
    // to the actual card count, keeping this geometry valid as steps change.
    var IMAGE_PANEL_RATIO = 0.6;

    function getStripOffset(continuousIndex) {
      // Translate the strip (in % of strip height) so the image at
      // continuousIndex is centered in the panel.
      var panelCenterInStripPct = 50 / (cards.length * IMAGE_PANEL_RATIO);
      var imageHeightPct = 100 / cards.length;
      return panelCenterInStripPct - (continuousIndex + 0.5) * imageHeightPct;
    }

    function updateStrip(deckState) {
      var cs = deckState.currentStep;
      var tp = deckState.transitionProgress;
      var isMobile = MOBILE_MQ.matches;
      var isLinear = isMobile || reduceMotion;
      var continuous = cs + tp;
      var frontIndex = deckState.centerIndex;

      if (isLinear || !strip) {
        // Mobile cards are interleaved with their text in DOM order.
        // The desktop strip transform does not apply there.
        return cs;
      }

      var offset = getStripOffset(continuous);

      if (reduceMotion) {
        // Keep manual rail selection instantaneous for reduced motion.
        var snapOffset = getStripOffset(Math.round(continuous));
        strip.style.transition = 'none';
        strip.style.transform = 'translateY(' + snapOffset.toFixed(3) + '%)';
      } else {
        // Continuous translateY follows the user's scroll position directly.
        strip.style.transition = '';
        strip.style.transform = 'translateY(' + offset.toFixed(3) + '%)';
      }

      return frontIndex;
    }

    function updateSteps(deckState) {
      var centerIndex = deckState.centerIndex;

      for (var j = 0; j < steps.length; j++) {
        var step = steps[j];
        var stepNum = parseInt(step.getAttribute('data-step'), 10);
        if (stepNum === centerIndex + 1) {
          step.classList.add('is-active');
        } else {
          step.classList.remove('is-active');
        }
      }
    }

    function updateRail(deckState) {
      if (!railItems.length) return;
      var centerIndex = deckState.centerIndex;
      railItems.forEach(function(item) {
        var idx = parseInt(item.getAttribute('data-rail-index'), 10);
        if (idx === centerIndex) {
          item.classList.add('is-active');
        } else {
          item.classList.remove('is-active');
        }
      });
    }

    function updateProgressBar(deckState) {
      if (!progressBar) return;
      progressBar.style.width = (deckState.scrollProgress * 100) + '%';
    }

    function updateMobileActive(frontIndex) {
      if (!MOBILE_MQ.matches) {
        if (mobileActiveCard !== -1 && cards[mobileActiveCard]) {
          cards[mobileActiveCard].removeAttribute('data-mobile-active');
        }
        mobileActiveCard = -1;
        return;
      }
      if (mobileActiveCard !== -1 && mobileActiveCard !== frontIndex && cards[mobileActiveCard]) {
        cards[mobileActiveCard].removeAttribute('data-mobile-active');
      }
      if (frontIndex >= 0 && frontIndex < cards.length && cards[frontIndex]) {
        cards[frontIndex].setAttribute('data-mobile-active', 'true');
      }
      mobileActiveCard = frontIndex;
    }

    function update() {
      var progress = getSectionProgress();
      var n = cards.length;
      var deckState = computeDeckState(progress, n);

      var frontIndex = updateStrip(deckState);
      updateSteps(deckState);
      updateRail(deckState);
      updateProgressBar(deckState);
      updateMobileActive(frontIndex);
    }

    /* --- Rail click: select the target step without moving the page -- */
    function jumpToStep(idx) {
      if (isNaN(idx) || idx < 0 || idx >= cards.length) return;
      var progress = cards.length > 1 ? idx / (cards.length - 1) : 0;
      var deckState = computeDeckState(progress, cards.length);
      var frontIndex = updateStrip(deckState);
      updateSteps(deckState);
      updateRail(deckState);
      updateProgressBar(deckState);
      updateMobileActive(frontIndex);
    }

    railItems.forEach(function(item) {
      item.addEventListener('click', function() {
        jumpToStep(parseInt(item.getAttribute('data-rail-index'), 10));
      });
      item.addEventListener('keydown', function(e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          jumpToStep(parseInt(item.getAttribute('data-rail-index'), 10));
        }
      });
    });

    var ticking = false;
    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(function() {
          update();
          ticking = false;
        });
        ticking = true;
      }
    }

    if (!reduceMotion) {
      window.addEventListener('scroll', onScroll, { passive: true });
    }
    window.addEventListener('resize', update, { passive: true });
    section._productScrollStoryCleanup = function() {
      if (!reduceMotion) window.removeEventListener('scroll', onScroll);
      window.removeEventListener('resize', update);
      MOBILE_MQ.removeEventListener('change', onMediaChange);
      if (mobileRevealObserver) mobileRevealObserver.disconnect();
    };

    update();
  }

  function initAll(root) {
    var scope = root || document;
    var selector = '[data-section-type="product-scroll-story"]';
    if (scope.matches && scope.matches(selector)) initSection(scope);
    var sections = scope.querySelectorAll ? scope.querySelectorAll(selector) : [];
    for (var i = 0; i < sections.length; i++) initSection(sections[i]);
  }

  if (registry.productScrollStory) {
    registry.productScrollStory(document);
    return;
  }
  registry.productScrollStory = initAll;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() { initAll(document); });
  } else {
    initAll(document);
  }
  document.addEventListener('shopify:section:load', function(event) { initAll(event.target); });
  document.addEventListener('shopify:section:unload', function(event) {
    var selector = '[data-section-type="product-scroll-story"]';
    var section = event.target.matches(selector) ? event.target : event.target.querySelector(selector);
    if (section && section._productScrollStoryCleanup) section._productScrollStoryCleanup();
  });
})();
